import * as React from 'react'
import toast from 'react-hot-toast'
import Label from '../../../forms/rjsf/common/rjsf-daisyui-theme/templates/FieldTemplate/Label.tsx'
import { sendCommand } from '../../../helpers/commandHelper.ts'
import { AsyncButton } from '../AsyncButton/AsyncButton.tsx'
import { PopupPortal } from '../Popup/PopupPortal.tsx'
import { PasswordInput } from './PasswordInput.tsx'

interface Props {
    open: boolean
    setOpen: (o: boolean) => void
}

const mustHave = 'Password must have six characters or more'
const noMatch = 'Passwords do not match'

export const ChangePassword: React.FC<Props> = (props) => {
    const {open, setOpen} = props
    const [oldPassword, setOldPassword] = React.useState('')
    const [newPassword, setNewPassword] = React.useState('')
    const [confirmPassword, setConfirmPassword] = React.useState('')
    const [pwErr, setPwErr] = React.useState(false)
    const [newPwErr, setNewPwErr] = React.useState(false)
    const [confirmErr, setConfirmErr] = React.useState(false)

    const buttonEnabled =
        oldPassword.length >= 6 &&
        newPassword.length >= 6 &&
        confirmPassword.length >= 6 &&
        newPassword === confirmPassword

    const doChange = async () => {
        const resultData = await sendCommand('changePassword', '', {oldPassword, newPassword})
        resetAndClose()
        if (!resultData) {
            toast.success('Password changed.')
        } else {
            toast.error(`Error, ${resultData.msg}.`)
        }
    }

    const resetAndClose = () => {
        setOldPassword('')
        setNewPassword('')
        setConfirmPassword('')
        setPwErr(false)
        setNewPwErr(false)
        setConfirmErr(false)
        setOpen(false)
    }

    const changeOld = (value: string) => {
        setPwErr(value.length > 0 && value.length < 6)
        setOldPassword(value)
    }

    const changeNew = (value: string) => {
        setNewPwErr(value.length > 0 && value.length < 6)
        setNewPassword(value)
        if (confirmPassword.length > 0) {
            setConfirmErr(value !== confirmPassword)
        }
    }

    const changeConfirm = (value: string) => {
        setConfirmErr(value.length > 0 && value !== newPassword)
        setConfirmPassword(value)
    }

    const error = (message: string) => (
        <div className={'relative'}>
            <ul className="error-detail bs-callout bs-callout-info text-danger absolute -top-4 left-1">
                <li className="text-base text-error text-xs" key={1}>
                    {message}
                </li>
            </ul>
        </div>
    )

    const panelHeader = (
        <div className={'prose flex flex-col justify-start items-center gap-2 pb-4'}>
            <h2 className={'mt-0 mb-0 text-primary'}>Change your Password</h2>
        </div>
    )

    const body = (
        <div className={'flex flex-col justify-start gap-8 items-center w-full'}>
            <div className={'relative w-full'}>
                <Label label={'Current Password'} required={true}/>
                <PasswordInput value={oldPassword} onChange={changeOld} placeholder={'current password'}/>
                {pwErr ? error(mustHave) : null}
            </div>
            <div className={'relative w-full'}>
                <Label label={'New Password'} required={true}/>
                <PasswordInput value={newPassword} onChange={changeNew} placeholder={'new password'}/>
                {newPwErr ? error(mustHave) : null}
            </div>
            <div className={'relative w-full'}>
                <Label label={'Confirm New Password'} required={true}/>
                <PasswordInput value={confirmPassword} onChange={changeConfirm} placeholder={'confirm new password'}/>
                {confirmErr ? error(noMatch) : null}
            </div>
        </div>
    )

    const panel = (
        <div className={'flex flex-col justify-start items-center gap-2 w-full p-6 min-w-[360px]'}>
            {panelHeader}
            {body}
        </div>
    )

    const buttons = (
        <div className={'px-6 pb-6 pt-2 flex justify-between items-center w-full'}>
            <button className={'btn btn-secondary btn-ghost btn-sm'} onClick={resetAndClose}>Dismiss</button>
            <AsyncButton classNames={'btn btn-outlined btn-primary btn-sm'} onClick={doChange}
                         disabled={!buttonEnabled}>Change</AsyncButton>
        </div>
    )

    return (
        <PopupPortal open={open}>
            {panel}
            {buttons}
        </PopupPortal>
    )
}
